<template>
  <div class="image-selector">
    <div class="image-list">
      <div v-for="image in images" :key="image.id" class="image-item" @click="selectImage(image)">
        <img :src="img_url + image.image_url	" alt="image" />
        <div v-if="selectedImageId === image.id" class="selected-overlay">
          <i class="el-icon-check"></i>
        </div>
      </div>
    </div>
    <el-pagination
      small
      layout="prev, pager, next"
      :total="total"
      :page-size="limit"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script>
import {getImages} from '@/api/image';
export default {
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      images: [],
      page: 1,
      limit: 12,
      total: 0,
      selectedImageId: null,
      img_url: process.env.VUE_APP_MEDIA_URL || ''


    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedImageId = newVal;
      }
    }
  },
  created() {
    this.fetchImages();
  },
  methods: {
    async fetchImages() {
      try {
        const res = await getImages({
          params: {
            page: this.page,
            limit: this.limit
          }
        });
        console.log(res);
        this.images = res.data.rows;
        this.total = res.data.total;
      } catch (error) {
        console.error(error);
      }
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchImages();
    },
    selectImage(image) {
      this.selectedImageId = image.id;
      this.$emit('input', image.image_url);
      this.$emit('change', image);
    }
  }
};
</script>

<style scoped>
.image-selector {
  width: 100%;
}
.image-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
}
.image-item {
  position: relative;
  cursor: pointer;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.selected-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
